import {
  Button,
  Sidebar,
  SidebarDelimiter,
  SidebarScrollLink,
  SidebarSubtitle,
  Link,
} from "@endya-conformite/ui-kit";
import { useIsAllowed } from "@src/session/useIsAllowed";
import { useMe } from "@src/store/store.me";
import { useParams } from "react-router-dom";
import ChevronLeft from "@endya-conformite/ui-kit/src/assets/icons/chevron-left.svg?react";
import { useCallback } from "react";
import { GatewayAuthentication } from "@conformite/gateway";

type SocieteInformationSidebarProps = {
  sectionRefs: React.MutableRefObject<{
    general?: HTMLDivElement | null;
    adresse?: HTMLDivElement | null;
    contact?: HTMLDivElement | null;
  }>;
  activeSection: "general" | "adresse" | "contact" | null;
  setActiveSection: (section: "general" | "adresse" | "contact" | null) => void;
};

export function SocieteInformationSidebar({
  sectionRefs,
  activeSection,
  setActiveSection,
}: SocieteInformationSidebarProps) {
  const { id } = useParams<{ id: string }>();
  const { hasAllowedCognitoRole } = useIsAllowed();
  const { me } = useMe();

  const scrollToSection = useCallback(
    (sectionKey: "general" | "adresse" | "contact") => {
      sectionRefs.current[sectionKey]?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
      setActiveSection(sectionKey);
    },
    [sectionRefs, setActiveSection]
  );

  return (
    <Sidebar
      hasRoleEndya={hasAllowedCognitoRole(GatewayAuthentication.Role.ENDYA)}
      prenom={me?.contact.prenom}
      nom={me?.contact.nom}
    >
      <Link to={`/societes/${id ?? ""}`}>
        <Button variant="text" icon={<ChevronLeft />}>
          Retour
        </Button>
      </Link>
      <SidebarDelimiter />
      <SidebarSubtitle>Informations société</SidebarSubtitle>
      <SidebarScrollLink
        onClick={() => scrollToSection("general")}
        isActive={activeSection === "general"}
      >
        Général
      </SidebarScrollLink>
      <SidebarScrollLink
        onClick={() => scrollToSection("adresse")}
        isActive={activeSection === "adresse"}
      >
        Adresse
      </SidebarScrollLink>
      <SidebarScrollLink
        onClick={() => scrollToSection("contact")}
        isActive={activeSection === "contact"}
      >
        Contact de médiation
      </SidebarScrollLink>
    </Sidebar>
  );
}
